import React from "react";
import { useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import CustomBlocks from "@/components/site/CustomBlocks";

export default function About({ previewSite }) {
  const outlet = useOutletContext();
  const site = previewSite || outlet?.site;
  if (!site) return null;
  const p = site.pages.about;
  return (
    <div data-testid="about-page">
      <section className="max-w-5xl mx-auto px-6 md:px-10 pt-20 pb-14">
        <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#9A8C73] mb-5">{p.hero.eyebrow}</p>
        <h1 className="font-display text-5xl md:text-6xl font-semibold tracking-tight text-[#1A201D] max-w-3xl">{p.hero.title}</h1>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-10 pb-24">
        <div className="font-display text-2xl md:text-3xl font-light leading-snug text-[#2C3531] rte-content" dangerouslySetInnerHTML={{ __html: p.mission.body }} />
      </section>

      <section className="bg-[#F3EFE7] py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="overflow-hidden rounded-[2.5rem] shadow-[0_20px_60px_rgba(44,53,49,0.12)]">
            <img src={p.synergy.image} alt="" className="w-full h-[420px] object-cover" />
          </motion.div>
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-semibold text-[#1A201D] mb-6">{p.synergy.title}</h2>
            <div className="text-[#4A5550] leading-relaxed mb-8 rte-content" dangerouslySetInnerHTML={{ __html: p.synergy.body }} />
            <ul className="space-y-4">
              {p.synergy.points.map((pt, i) => (
                <li key={i} className="flex gap-3">
                  <span className="shrink-0 w-6 h-6 rounded-full bg-[#9A8C73] text-white flex items-center justify-center"><Check className="w-3.5 h-3.5" /></span>
                  <span className="text-[#2C3531] leading-relaxed">{pt.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-10 py-24">
        <h2 className="font-display text-4xl md:text-5xl font-semibold text-[#1A201D] mb-12">{p.why.title}</h2>
        <div className="grid md:grid-cols-2 gap-px bg-[#E5DFD3] rounded-2xl overflow-hidden border border-[#E5DFD3]">
          <div className="bg-[#FDFBF7] p-8">
            <p className="uppercase tracking-[0.15em] text-xs font-bold text-[#9A8C73] mb-6">Traditional PPC / SEO Route</p>
            <ul className="space-y-4">
              {p.why.rows.map((r, i) => (
                <li key={i} className="flex gap-3 text-[#4A5550]">
                  <X className="w-5 h-5 text-[#993333] shrink-0 mt-0.5" /> <span>{r.ppc}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-[#2C3531] p-8 text-[#FDFBF7]">
            <p className="uppercase tracking-[0.15em] text-xs font-bold text-[#9A8C73] mb-6">The Whitelabel Partner Route</p>
            <ul className="space-y-4">
              {p.why.rows.map((r, i) => (
                <li key={i} className="flex gap-3 text-[#FDFBF7]/85">
                  <Check className="w-5 h-5 text-[#9A8C73] shrink-0 mt-0.5" /> <span>{r.whitelabel}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <CustomBlocks blocks={p.blocks} />
    </div>
  );
}
